import { useState, useEffect } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      onClick={scrollTop}
      aria-label="Back to top"
      data-testid="back-to-top"
      className="fixed bottom-8 right-8 z-40 w-10 h-10 flex items-center justify-center border transition-all duration-500"
      style={{
        borderColor: 'var(--rule-strong)',
        backgroundColor: 'rgba(10,10,10,0.85)',
        backdropFilter: 'blur(12px)',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
        transform: visible ? 'translateY(0)' : 'translateY(12px)',
      }}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--text-tertiary)" strokeWidth="1.5">
        <polyline points="18 15 12 9 6 15" />
      </svg>
    </button>
  );
}
